<template>
  <div class="navHead clearfix">
    <div class="wrap" :class="{ 'scrolled': isScrolled }">
      <a @click="logoClick">
        <div class="logo">
          <img :src="logoimg"/>
        </div>
      </a>
      <!--      nav导航栏-->
      <div class="nav">
        <ul class="clearfix">
          <li
              v-for="(item, index) in navList"
              :key="index"
              @click="funyuming(item, $event)"
              style="font-weight: bold;"
          >
            {{ $t(item.i18nKey) }}
          </li>
        </ul>
      </div>
      <!-- 语言切换组件 -->
      <div class="lang-switch-container">
        <!--{{$t('common.language')}}: --> <LangSwitcher />
      </div>
      <!--      nav导航栏子项-->
      <div class="nav-item" ref="nav-item" :style="navItemStyle">
        <ul class="item-name">
          <li v-for="(item,index) in navItem" :key="index" @click.stop="navItemChildClic($event,item)">
            <!--            <router-link :to="item.url" class="item-name-router" v-if="item.url">{{ item.title }}</router-link>-->
            <!--            <span class="item-name-router" v-if="!item.url">{{ item.title }}</span>-->
            {{ item.title }}
          </li>
        </ul>
        <!--        二级导航栏-->
        <div class="nav-item-child clearfix">
          <ul class="item-name-ul" v-show="navItemChild!=null">
            <li v-for="(item,index) in navItemChild" :key="index" @click="restart(item.url)">
              {{ item.title }}
            </li>
          </ul>

          <dl class="item-name-dl" v-show="navItemChildDl!=null" v-for="(item,index) in navItemChildDl" :key="index">
            <dt class="item-name-dt" @click="dtOnclick(item)">{{ item.name }}</dt>
            <dd class="el-icon-caret-right" v-for="(itemOptions,index) in item.options" :key="index"
                @click="ddOnclick(itemOptions)">
              {{ itemOptions.name }}
            </dd>
          </dl>
        </div>
      </div>

      <!--   移动端nav栏样式   -->
      <div class="phone-nav-class">
        <el-button class="el-icon-more" @click="handlePhoneNavClick"></el-button>
      </div>
      <div class="curtain" :style="curtainStyle" @click="curtainFunction($event)"></div>

<!--      <div class="email">-->
<!--        <span class="el-icon-phone-outline"></span>-->
<!--        {{ $t('footer.serviceHotline') }}: 180 0182 0616-->
<!--      </div>-->
    </div>

    <el-drawer
        :visible.sync="drawer"
        size="100%"
        :show-close="false"
    >

      <!--    移动端菜单  -->
      <!--      @open="handleOpen" @close="handleClose"-->
      <el-menu default-active="1-4-1" unique-opened class="el-menu-vertical-demo" @select="menuSelect">
        <!-- 具有下级菜单的一级菜单  -->
        <el-submenu :index="`${menuIndex}`" v-for="(menuItem, menuIndex) in navPhone"
                    :key="menuIndex" v-if="menuItem.url==null">
          <template slot="title">
            <span slot="title">{{ $t(menuItem.i18nKey) }}</span>
          </template>
          <!--  具有三级菜单的二级菜单  -->
          <el-submenu :index="`${menuIndex}-${menu2Index}`"
                      v-for="(menu2Item,menu2Index) in menuItem.options" :key="menu2Index"
                      v-if="menu2Item.optionsOl!=null || menu2Item.options!=null">
            <template slot="title">
              <span slot="title">{{ menu2Item.title }}</span>
            </template>
            <!-- 三级菜单-展示产品 -->
            <el-menu-item-group>
              <el-menu-item v-if="menu2Item.optionsOl!=null"
                            :index="`${menuIndex}-${menu2Index}-${menu3Index}`"
                            v-for="(menu3Item,menu3Index) in menu2Item.optionsOl" :key="menu3Index">
                {{ menu3Item.name }}
              </el-menu-item>
            </el-menu-item-group>
            <!--  三级菜单-展示页面   -->
            <el-menu-item-group v-if="menu2Item.options!=null"
                                v-for="(menu3Item,menu3Index) in menu2Item.options" :key="menu3Index">
              <el-menu-item :index="`${menuIndex}-${menu2Index}-${menu3Index}`">
                {{ menu3Item.title }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!--  不具有三级菜单的二级菜单  -->
          <el-menu-item-group>
            <el-menu-item :index="`${menuIndex}-${menu2Index}`"
                          v-for="(menu2Item,menu2Index) in menuItem.options" :key="menu2Index"
                          v-if="menu2Item.optionsOl==null && menu2Item.options==null">
              {{ menu2Item.title }}
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>

        <!-- 不具有下级菜单的一级菜单  -->
        <el-menu-item-group>
          <el-menu-item :index="`${menuIndex}`" v-for="(menuItem, menuIndex) in navPhone"
                        :key="menuIndex" v-if="menuItem.url!=null">
            {{ $t(menuItem.i18nKey) }}
          </el-menu-item>
        </el-menu-item-group>
      </el-menu>
    </el-drawer>
  </div>
</template>

<script>
import $ from 'jquery'
import {entranceGuard} from "@/assets/js/entranceGuard.js";
import {displayCase} from "@/assets/js/displayCase.js";
import LangSwitcher from '@/components/LangSwitcher.vue';

export default {
  name: "Nav",
  inject: ["reloadApp"],
  components: {
    LangSwitcher
  },
  data() {
    return {
      drawer: false,
      isScrolled: false, // 是否已滚动
      navList: [
        // {title: "关于我们", id: "briefIntroduction", i18nKey: "common.about"},
        {title: "服务支持", id: "support", i18nKey: "common.support"},
        {title: "产品中心", id: "product", i18nKey: "common.products"},
        {title: "联系我们", id: "contact", url: "/contact", i18nKey: "common.contact"}
      ],
      logoimg: require("@/assets/img/logo.png"),
      // 显示隐藏
      navItemStyle: '',
      navItemId: null, // 存储一级栏id
      curtainStyle: 'display: none',
      navItem: [], // 存储一级栏
      navItemChildId: null,// 存储二级栏id
      navItemChild: [],// 存储二级栏ul
      navItemChildDl: [],// 存储二级栏ol
      navOptions: [
        // 一项tart
        {
          id: 'briefIntroduction',
          options: [
            {
              title: this.$t('nav.about'),
              url: '/briefIntroduction'
            }
          ]
        },
        // end

        {
          id: 'product',
          options: [
            {
              title: this.$t('nav.productLibrary'),
              name: "productLibrary",
              options: [
                {
                  title: this.$t('nav.accessControl'),
                  url: "/product/entranceGuard"
                },
                {
                  title: this.$t('nav.smartCabinet'),
                  url: "/product/displayCase"
                }
              ]
            },
            {
              title: this.$t('nav.accessControl'),
              name: "entranceGuard",
              optionsOl: []
            },
            {
              title: this.$t('nav.smartCabinet'),
              name: "displayCase",
              optionsOl: []

            },
            {
              title: this.$t('nav.softwarePlatform'),
              name: "softwarePlatform",
              options: [
                {
                  title: this.$t('nav.accessControlPlatform'),
                  name: "entranceGuardSoftware",
                  url: '/product/softwarePlatform/entranceGuardSoftware'
                },
                {
                  title: this.$t('nav.displayPlatform'),
                  name: "exhibitionSoftware",
                  url: '/product/softwarePlatform/exhibitionSoftware'
                },
                {
                  title: this.$t('nav.afterSalesPlatform'),
                  name: "aftersales",
                  url: '/product/softwarePlatform/aftTheSoftware'
                },
              ]
            },
          ]
        },
        {
          id: 'support',
          options: [
            // {
            //   title: "寻找合作伙伴",
            //   name: "cooperation",
            //   url: '/support/cooperation'
            // },
            {
              title: this.$t('nav.services'),
              name: "provideServices",
              options: [
                {
                  title: this.$t('nav.accessControlSolution'),
                  name: "accessControlIntelligentSystemServices",
                  url: '/service/accessControlIntelligentSystemServices'
                },
                {
                  title: this.$t('nav.smartDisplaySolution'),
                  name: "smartDisplayCaseService",
                  url: '/service/smartDisplayCaseService'
                },
                {
                  title: this.$t('nav.smartLockerSolution'),
                  name: "smartLockersService",
                  url: '/service/smartLockersService'
                },
                {
                  title: this.$t('nav.glassDoorSolution'),
                  name: "glassDoorHandleSmartLockService",
                  url: '/service/glassDoorHandleSmartLockService'
                },
                // {
                //   title: this.$t('nav.smartBuildingSolution'),
                //   name: "smartBuildingsService",
                //   url: '/service/smartBuildingsService'
                // }
              ]
            },
          ]
        },
        // {
        //   id: 'contact',
        //   options: [
        //     {
        //       title: "联系我们",
        //       name: "contact",
        //       url: '/contact'
        //     },
        //   ]
        // },


      ],
      // 适配手机的
      navPhone: []
    };
  },
  mounted() {
    this.initNavPhone()
    $(function (document) {
    })
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    // 组件销毁前移除滚动监听
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      // 当滚动超过50px时，设置isScrolled为true
      this.isScrolled = window.scrollY > 50

      // 如果二级菜单是显示状态，则更新其位置
      if (this.navItemId != null) {
        if (this.isScrolled) {
          $(".nav-item").css("top", "3.5rem")
        } else {
          $(".nav-item").css("top", "5rem")
        }
      }
    },
    logoClick() {
      this.drawer === true ? this.drawer = false : this.drawer = false
      this.$router.push("/")
    },
    initNavPhone() {
      // 封装 phone 的菜单
      this.navPhone = JSON.parse(JSON.stringify(this.navList))
      this.navPhone.forEach(item => {
        // 封装2级菜单
        const options2 = []
        this.navOptions.forEach(item2 => {
          if (item.id == item2.id) {
            options2.push(...item2.options)
          }
        })
        item.options = options2
        // 封装3级菜单
        item.options.forEach(it2o => {
          if (it2o.optionsOl != null) {
            switch (it2o.name) {
              case 'entranceGuard':
                let entranceGuardOptions3 = []
                entranceGuard.forEach(it => {
                  entranceGuardOptions3.push({name: it.categoryName, options: it.catgItem})
                })
                it2o.optionsOl = entranceGuardOptions3
                break
              case 'displayCase':
                let displayCaseOptions3 = []
                displayCase.forEach(it => {
                  displayCaseOptions3.push({name: it.categoryName, options: it.catgItem})
                })
                it2o.optionsOl = displayCaseOptions3
                break
            }
          }
        })
      })
    },
    handlePhoneNavClick() {
      this.drawer = !this.drawer
    },
    menuSelect(key, keyPath) {
      keyPath.forEach((it, index) => {
        let itemIndex = it.split('-')
        if (itemIndex.length === 1) {
          // 一级菜单 当存在url时跳转
          let navItem = this.navPhone[itemIndex[0]]
          if (navItem.url != null) {
            this.$router.push(navItem.url)
            this.handlePhoneNavClick()
          }
        }
        if (itemIndex.length === 2) {
          // 二级菜单
          let navItem = this.navPhone[itemIndex[0]]
          if (navItem && navItem.options) {
            let navItem2 = navItem.options[itemIndex[1]]
            if (navItem2.url) {
              this.$router.push(navItem2.url)
              this.handlePhoneNavClick()
            }
          }
        }
        if (itemIndex.length === 3) {
          // 三级菜单
          let navItem = this.navPhone[itemIndex[0]]
          if (navItem && navItem.options) {
            // 获取到二级
            let navItem2 = navItem.options[itemIndex[1]]
            // 获取到三级
            if (navItem2 && navItem2.options) {// 页面跳转
              let navItem3 = navItem2.options[itemIndex[2]]
              if (navItem3.url) {
                this.$router.push(navItem3.url)
                this.handlePhoneNavClick()
              }
            }
            if (navItem2 && navItem2.optionsOl) {// 产品展示
              let navItem3 = navItem2.optionsOl[itemIndex[2]]
              if (navItem3) {
                this.dtOnclick(navItem3)
                this.handlePhoneNavClick()
              }
            }
          }
        }
      })
    },
    // 重载页面
    restart(url) {
      this.$router.push(url)
      this.reloadApp()
    },
    // 一级菜单
    funyuming(item, e) {
      if (item.url) {
        this.$router.push(item.url)
        this.reloadApp()
        return
      }
      let id = item.id
      this.navOptions.forEach(it => {
        if (it.id == id) {
          this.navItem = it.options
        }
      })
      if (this.navItemId == null || this.navItemId != id) {
        this.navItemId = id

        // 先设置样式和位置
        $(".nav>ul li").css("borderBottom", "none")
        $(e.target).css("borderBottom", "3px solid #2ab05a")
        this.curtainStyle = 'display: block'

        // 设置二级菜单位置，确保紧贴导航栏底部
        if (this.isScrolled) {
          $(".nav-item").css("top", "3.5rem")
        } else {
          $(".nav-item").css("top", "5rem")
        }

        // 先隐藏二级导航栏
        $(".nav-item-child").hide()
        $(".item-name li,.item-name-router").css("borderBottom", "none")
        this.navItemChildId = null
        this.navItemChild = []
        this.navItemChildDl = []

        // 最后显示菜单，使用show()代替fadeIn()以避免闪动
        $(".nav-item").show()

      } else if (this.navItemId == id) {
        this.navItemId = null
        this.navItem = []
        this.curtainStyle = 'display: none'
        $(".nav-item").hide()
        $(e.target).css("border-bottom", "none")
        this.curtainStyle = 'display: none'
      }
    },
    // 二级菜单
    navItemChildClic(e, item) {
      const that = this
      if (item.options == null && item.optionsOl == null) {
        this.curtainStyle = 'display: none' // 隐藏幕布
        that.$router.push(item.url)
        {
          this.reloadApp()
        }

        // 不存在二级菜单
        return false
      }
      /*      $(".nav-item>.item-name>li").css("borderBottom", "none")
            $(e.target).css("borderBottom", "3px solid #2ab05a")*/
      // 存在二级菜单
      if (this.navItemChildId != item.name && item.options != null) {
        // 清空dl样式
        this.navItemChildDl = []

        // 先设置样式
        $(".item-name li,.item-name-router").css("borderBottom", "none")
        $(e.target).css("borderBottom", "3px solid #2ab05a")

        // 设置数据
        this.navItemChildId = item.name
        this.navItemChild = item.options

        // 最后显示菜单，使用show()代替fadeIn()
        $(".nav-item-child").show()

      } else if (this.navItemChildId != item.name && item.optionsOl != null) {
        // 清空ul
        this.navItemChild = []

        // 先设置样式
        $(".item-name li,.item-name-router").css("borderBottom", "none")
        $(e.target).css("borderBottom", "3px solid #2ab05a")

        // dl样式
        // 获取到内容
        switch (item.name) {
          case 'entranceGuard':
            item.optionsOl = []
            entranceGuard.forEach(it => {
              item.optionsOl.push({name: it.categoryName, options: it.catgItem})
            })
            break
          case 'displayCase':
            item.optionsOl = []
            displayCase.forEach(it => {
              item.optionsOl.push({name: it.categoryName, options: it.catgItem})
            })
            break
        }

        // 设置数据
        this.navItemChildId = item.name
        this.navItemChildDl = item.optionsOl

        // 最后显示菜单，使用show()代替fadeIn()
        $(".nav-item-child").show()

      } else if (this.navItemChildId != null && this.navItemChildId == item.name) {
        $(".nav-item-child").hide()
        this.navItemChildId = null
        this.navItemChild = []
        this.navItemChildDl = []
        $(e.target).css("border-bottom", "none")
      }
    },
    curtainFunction(e) {
      this.navItemId = null
      this.curtainStyle = 'display: none'
      $(".nav-item").hide()
      $(".nav-item-child").hide()
      $(".nav>ul li").css("borderBottom", "none")
      $(".item-name li,.item-name-router").css("borderBottom", "none")

      this.navItemId = null
      this.navItem = []

      this.navItemChildId = null
      this.navItemChild = []
      this.navItemChildDl = []
    },
    // 二级标签 dt栏处理
    dtOnclick(data) {
      this.curtainStyle = 'display: none' // 隐藏幕布
      this.$router.push({
        name: "productShow",
      })

      sessionStorage.setItem("product", JSON.stringify(data))
      {
        this.reloadApp()
      }
    },
    // 二级标签栏 dd标签处理
    ddOnclick(data) {
      this.curtainStyle = 'display: none' // 隐藏幕布

      this.$router.push({
        name: "productInfoShow",
        query: {
          item: data.id
        }
      })
      {
        this.reloadApp()
      }

    },
    // funRouter() {
    //   this.$router.push("/product/entranceGuard");
    // },
    // funAfterSales() {
    //   this.$router.push("/aftersales");
    // }
  },

};


</script>
<style scoped lang="scss">

::v-deep .el-drawer__header {
  margin-bottom: 4.5rem;
}

.navHead {
  height: 3rem;
}

.wrap {
  position: fixed;
  z-index: 9999;
  width: 100vw;
  //min-width: 750px;
  height: 5rem;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 3px #e5e5e5;
  margin: 0 auto;
  transition: all 0.3s ease; /* 添加过渡效果 */
}

.wrap.scrolled {
  height: 3.5rem; /* 滚动后的高度 */
}

.logo {
  cursor: pointer;

  & > img {
    position: absolute;
    left: 45px;
    top: 0.7rem;
    width: 6rem;
    transition: all 0.3s ease; /* 添加过渡效果 */
  }
}

.wrap.scrolled .logo > img {
  width: 4.5rem; /* 滚动后logo变小 */
  top: 0.5rem;
}

.phone-nav-class {
  display: none;
  position: absolute;
  z-index: 1;
  top: 30%;
  right: 3rem;
}

.nav {
  position: absolute;
  z-index: 999;
  left: 15rem;
  top: 2rem;
  transition: all 0.3s ease; /* 添加过渡效果 */

  ul {
    height: 100%;

    li {
      height: 2rem;
      float: left;
      display: flex;
      list-style-type: none;
      color: $shanMai_blue;
      font-size: 1.4rem;
      margin-right: 30px;
      line-height: 50%;
      cursor: pointer;
      user-select: none;
      -webkit-tap-highlight-color: transparent;

      &:hover {
        color: $shanMai_green;
      }
    }
  }
}

.wrap.scrolled .nav {
  top: 1.2rem; /* 滚动后导航位置上移 */
}

.nav-item {
  display: none;
  position: fixed; /* 使用固定定位 */
  z-index: 100;
  left: 0;
  width: 100vw;
  //min-width: 750px;
  height: 4.5rem;
  /* 位置由JavaScript动态控制 */
  background-color: #f2f2f2;
  box-shadow: 0 6px 6px #a3a3a3;
  border-bottom: 0.5rem solid $shanMai_blue;
  transition: all 0.3s ease; /* 添加过渡效果 */
  opacity: 1; /* 确保完全不透明 */

  .item-name {
    display: flex;
    flex-wrap: wrap;
    width: 80%;
    margin-left: 4rem;
    -webkit-tap-highlight-color: transparent;

    li {
      padding: 1.5rem 3rem;
      user-select: none;
      color: $shanMai_blue;
      font-size: 1.1rem;
      user-select: none;
      cursor: pointer;

      &:hover {
        color: $shanMai_green;
      }
    }
  }

  //  二级菜单
  .nav-item-child {
    display: none;
    position: absolute;
    z-index: 6;
    width: 100%;
    //min-width: 750px;
    height: auto;
    background-color: #ffffff;
    padding-bottom: 2rem;
    top: 4.5rem; /* 设置为二级菜单的高度 */
    left: 0; /* 确保水平对齐 */
    box-shadow: 0 0.3rem 0.2rem #a3a3a3;
    opacity: 1; /* 确保完全不透明 */
  }

  .item-name-ul {
    display: flex;

    padding: 2rem 0 0 1rem;

    li {
      margin-left: 5rem;

      color: $shanMai_blue;
      font-size: 1rem;
      user-select: none;
      cursor: pointer;

      &:hover {
        color: $shanMai_green;
      }
    }
  }

  .item-name-dl {
    width: 18%;
    height: 15rem;
    float: left;
    margin-left: 5rem;
    cursor: pointer;
    user-select: none;
    line-height: 1.7;

    .item-name-dt {
      font-size: 1.2rem;
      font-weight: 700;
      margin-bottom: 1rem;
      margin-top: 1rem;
      border-bottom: 1px solid #8e8e8e;

      &:hover {
        color: $shanMai_blue;
      }
    }

    dd {
      width: 25rem;
      line-height: 2.2;
      padding-left: 1rem;
      color: #2b2b2b;

      &:hover {
        color: $shanMai_green;
      }
    }
  }
}

/* 滚动状态下的二级菜单位置 */
.wrap.scrolled + .nav-item {
  top: 3.5rem; /* 与滚动后导航栏高度一致 */
}

.curtain {
  position: absolute;
  width: 100%;
  height: 1000px;
}

.dropdown-content {
  a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    margin-top: 10px;

    &:hover {
      background-color: #f1f1f1;
    }
  }
}

.dropdown {
  &:hover {
    .dropdown-content {
      display: block;
    }
  }
}

.email {
  position: absolute;
  display: flex;
  align-items: center;
  top: 30%;
  right: 5rem;
  transition: all 0.3s ease; /* 添加过渡效果 */

  span {
    display: block;
    width: 2.5rem;
    height: 2.5rem;
    background-color: #a3a3a3;
    border-radius: 1.5rem;
    margin-right: 1rem;
    text-align: center;
    line-height: 2.5rem;
    font-size: 2rem;
    color: white;
    transition: all 0.3s ease; /* 添加过渡效果 */
  }
}

.wrap.scrolled .email {
  top: 20%; /* 滚动后位置上移 */
}

.wrap.scrolled .email span {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.6rem;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.lang-switch-container {
  position: absolute;
  right: 30rem;
  top: 40%;
  z-index: 9999;
  transition: all 0.3s ease; /* 添加过渡效果 */
}

.wrap.scrolled .lang-switch-container {
  top: 30%; /* 滚动后位置上移 */
}

/* 移动端样式 */
@media screen and (max-width: 1100px) {
  .email {
    display: none !important;
  }
  .lang-switch-container {
    right: 5rem;
  }
  .wrap.scrolled .lang-switch-container {
    top: 25%; /* 移动端滚动后位置调整 */
  }
}

@media screen and (max-width: 750px) {
  .nav {
    display: none !important;
  }
  .phone-nav-class {
    display: block;
    transition: all 0.3s ease;
  }
  .wrap.scrolled .phone-nav-class {
    top: 20%;
  }
  .lang-switch-container {
    right: 7.5rem;
    top: 53%;
    transform: translateY(-50%);
  }
  .wrap.scrolled .lang-switch-container {
    top: 50%;
  }
}

.content-box {
  margin-top: 80px;
  transition: all ease-in 0.1s;
}
.wrap.scrolled .content-box {
  margin-top: 56px;
}
</style>

<style>
/* 全局样式，确保下拉菜单在最上层 */
.el-dropdown-menu {
  z-index: 10000 !important;
}
</style>
